const initialState = {
  cartData: [],
};

const cartConfig = (state = initialState, action) => {
  if (action.type == "Add") {
    return {
      ...state,
      cartData: [...state.cartData, action.payload],
    };
  } else if (action.type === "Clear") {
    return {
      cartData: action.payload,
    };
  }
  return state;
};
export default cartConfig;
